import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { AlertService } from '../../../core/services/alert/alert.service';
import { ApiService } from '../../../core/services/api/api.service';
import { ToastService } from '../../../core/services/toast/toast.service';
import { Role } from '../../../models/enums/role.enum';
import { cloneDeep } from 'lodash-es';
import { firstValueFrom } from 'rxjs';
import { formatRole } from '../../../shared/utils/format-role.util';
import { EnfafModalComponent } from '../../enfaf-modal/enfaf-modal.component';
import { EnfafSelectLightComponent } from '../../enfaf-select-light/enfaf-select-light.component';

@Component({
  selector: 'app-modal-change-role',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    EnfafModalComponent,
    EnfafSelectLightComponent
  ],
  templateUrl: './modal-change-role.component.html',
  styleUrl: './modal-change-role.component.scss'
})
export class ModalChangeRoleComponent implements OnInit {
  name!: string;
  currentRole!: Role;
  showCloseAlert = false;
  changeForm!: FormGroup;
  roleEnum = Role;
  isChangingRole = false;

  formatRole = formatRole;

  roleOptions = [
    { value: Role.God, viewValue: formatRole(Role.God) },
    { value: Role.Teacher, viewValue: formatRole(Role.Teacher) },
    { value: Role.Tutor, viewValue: formatRole(Role.Tutor) },
    { value: Role.Student, viewValue: formatRole(Role.Student) },
    { value: Role.ContentDirector, viewValue: formatRole(Role.ContentDirector) }
  ];

  get title(): string {
    return `Cambiar rol a ${this.data.name} ${this.data.lastname}`;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { currentRole: Role; userId: string; name: string; lastname: string },
    private dialogRef: MatDialogRef<ModalChangeRoleComponent>,
    private alert: AlertService,
    private api: ApiService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  async confirmCloseModal(): Promise<any> {
    if (this.showCloseAlert) {
      const closeModal = await this.alert.presentCloseWindowAlert();
      return closeModal ? this.closeModal() : null;
    }

    this.closeModal();
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  initForm(): void {
    const { currentRole, userId, name } = this.data;
    if (!currentRole || !userId || !name) {
      this.closeModal();
      return;
    }

    this.currentRole = currentRole;
    this.name = name;

    this.changeForm = new FormGroup({
      userId: new FormControl(userId, Validators.required),
      role: new FormControl(currentRole, Validators.required)
    });
    console.log(this.changeForm.value);
  }

  async changeRole(): Promise<void> {
    try {
      this.isChangingRole = true;
      const body = this.changeForm.value;
      const response = await firstValueFrom(this.api.changeRole(body));
      this.isChangingRole = false;
      this.toast.presentSuccessToast(response.message);
      this.closeModal({ changed: true });
    } catch (errorResponse: any) {
      this.isChangingRole = false;
      const errorMessage = errorResponse?.error?.message;
      this.toast.presentErrorToast(errorMessage || 'Hubo un error cambiando de rol al usuario');
    }
  }
}
